import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { GET_BRAND } from '../../graphql/queries/brand';
import { ErrorState, RootState } from '../../redux/AppReducer';
import { BrandVM } from '../../common/view-model';
import { FC, useEffect, useState } from 'react';
import { mapBrandAttributes } from '../../components/brand-profile/model';
import BrandProfileComponent from '../../components/brand-profile/BrandProfileComponent';
import { AppActions } from '../../redux/AppActions';
import { GENERAL_ERRORS, serverError } from '../../common/constants';
import { useAppDispatch } from '../../redux/store';
import { AuthActions } from '../../redux/AuthActions';

const BrandDatail: FC = () => {
	const { brandId } = useParams();
	const dispatch = useAppDispatch();
	const [brand, setBrand] = useState<BrandVM | undefined>();
	const currentEvent = useSelector(
		(state: RootState) => state.appState?.storeState?.getCurrentEvent
	);
	const tokenHasError = useSelector(
		({ appState: state }: RootState) => state.authState?.tokenHasError
	);
	const { data, loading, error } = useQuery<any>(GET_BRAND, {
		variables: { id: brandId, expoEventId: currentEvent?.id },
		skip: currentEvent === undefined
	});
	const handleError = (error: ErrorState) => dispatch(AppActions.setGeneralError(error));
	const handleUnauthorized = () => dispatch(AppActions.unauthorizedError());
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	useEffect(() => {
		if (!error && !loading && data?.brand) {
			const { __typename, ...rest } = data.brand;
			setBrand(mapBrandAttributes(rest));
		}
	}, [data, error, loading]);

	useEffect(() => {
		if (error?.message === 'Unauthorized') {
			if (tokenHasError === 0) {
				dispatch(AuthActions.setTokenError(1));
			}
		}
		if (error?.message === GENERAL_ERRORS.USER_TOKEN_EXPIRED) {
			handleUnauthorized();
		}
		if (error) {
			handleError(serverError);
		}
	}, [error]);
	return <>{brand && <BrandProfileComponent brand={brand} currentEvent={currentEvent} />}</>;
};

export default BrandDatail;
